(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').factory('mx.SolutionBuilderAgent.ConditionsBuilder.Group', ClassFactory);
	ClassFactory.$inject = [
		'mx.SolutionBuilderAgent.ConditionsBuilder.Helper',
		'mx.SolutionBuilderAgent.ConditionsBuilder.Enums',
		'mx.SolutionBuilderAgent.ConditionsBuilder.Condition',
	];

	function ClassFactory(helper, ConditionsBuilderEnums, ConditionsBuilderCondition) {
		var ConditionBuilderMode = ConditionsBuilderEnums.ConditionBuilderMode;

		function ConditionsBuilderGroup(groupOptions, config) {
			groupOptions = groupOptions || {};
			var self = this;
			var expanded = true;

			Object.defineProperty(this, '_builderConfig', {
				writable: false,
				enumerable: false,
				value: config,
			});

			Object.defineProperty(this, 'groups', {
				writable: true,
				enumerable: true,
				value: [],
			});

			Object.defineProperty(this, 'conditions', {
				writable: true,
				enumerable: true,
				value: [],
			});

			Object.defineProperty(this, 'id', {
				writable: true,
				enumerable: true,
				value: groupOptions.Id || mx.components.Utils.guid(),
			});

			Object.defineProperty(this, 'parent', {
				writable: false,
				enumerable: false,
				value: groupOptions.parent,
			});

			['logicOperator'].forEach(function (fieldName) {
				helper.definePropertiesForEnums(fieldName, self);
			});
			this.logicOperatorValue = groupOptions.LogicOperator;

			Object.defineProperty(this, 'expanded', {
				enumerable: false,
				get: function () {
					return expanded;
				},
				set: function (newValue) {
					expanded = newValue;
					this.conditions.forEach(function (condition) {
						condition.expanded = newValue;
					});
					this.groups.forEach(function (group) {
						group.expanded = newValue;
					});
				},
			});

			Object.defineProperty(this, 'properties', {
				enumerable: false,
				configurable: true,
				get: function () {
					return this.parent ? this.parent.properties : [];
				},
			});

			Object.defineProperty(this, 'attributes', {
				enumerable: false,
				configurable: true,
				get: function () {
					return this.parent ? this.parent.attributes : [];
				},
			});

			Object.defineProperty(this, 'level', {
				writable: true,
				enumerable: false,
				value: groupOptions.Level || 0,
			});

			if (Array.isArray(groupOptions.Groups)) {
				groupOptions.Groups.forEach(function (g) {
					this.addGroup(g);
				}, this);
			}

			if (Array.isArray(groupOptions.Conditions)) {
				groupOptions.Conditions.forEach(function (c) {
					this.addCondition(c);
				}, this);
			}

			this.initialized = true;
			this.updateOutput();
		}

		ConditionsBuilderGroup.prototype = {
			getChildrenOperator: function () {
				if (this._builderConfig.mode === ConditionBuilderMode.enableDifferentOperatorsInGroup) {
					return false;
				}
				if (this.conditions.length > 1) {
					return this.conditions[1].logicOperatorValue;
				}
				if (this.conditions.length + this.groups.length > 1) {
					return this.groups[0].logicOperatorValue;
				}
				if (this.groups.length > 1) {
					return this.groups[1].logicOperatorValue;
				}
				return false;
			},

			/**
			 * @ngdoc method
			 * @name mx.SolutionBuilderAgent.RuleGroup#addGroup
			 *
			 * @description
			 * Adds new group as a child group of a current group.<br>
			 *
			 * @param {mx.SolutionBuilderAgent.SearchQueryGroup} group - Child group model
			 * @return {boolean} True if child group was added.<br>False if child group was not added as it already existed as a child
			 */
			addGroup: function (groupOptions) {
				groupOptions = angular.copy(groupOptions) || {};
				groupOptions.parent = this;
				var logicOperator = this.getChildrenOperator();
				if (logicOperator !== false) {
					groupOptions.LogicOperator = logicOperator;
				}
				groupOptions.Level = this.level + 1;
				this.groups.push(new ConditionsBuilderGroup(groupOptions, this._builderConfig));
				this.updateOutput();
				return true;
			},

			/**
			 * @ngdoc method
			 * @name mx.SolutionBuilderAgent.RuleGroup#removeGroup
			 *
			 * @description
			 * Removes group from current group's children.<br>
			 * If specified child group does not exist no actions performed.
			 *
			 * @param {mx.SolutionBuilderAgent.SearchQueryGroup} group - Child group model
			 * @return {boolean} True if child group was removed.<br>False if child group was not removed as it was not found among child groups
			 */
			removeGroup: function (group) {
				if (!group) {
					throw new Error('SearchQueryGroup: removeGroup group is not provided');
				}
				var index = this.groups.indexOf(group);

				if (index === -1) {
					return false;
				}
				this.groups.splice(index, 1);
				this.updateOutput();
				return true;
			},

			toggleLogicalOperator: function () {
				this.logicOperator = (this.logicOperator + 1) % this.logicOperators.length;

				if (this.parent && this._builderConfig.mode === ConditionBuilderMode.disableDifferentOperatorsInGroup) {
					this.parent.setLogicOperatorForChildren(this.logicOperator);
				}
			},

			setLogicOperatorForChildren: function (operator) {
				this.groups.forEach(function (group) {
					group.logicOperator = operator;
				});
				this.conditions.forEach(function (condition) {
					condition.logicOperator = operator;
				});
			},

			/**
			 * @ngdoc method
			 * @name mx.SolutionBuilderAgent.SearchQueryGroup#addCondition
			 *
			 * @description
			 * Adds new condition to current group.<br>
			 * If condition exists within current group no actions performed.
			 *
			 * @param {mx.SolutionBuilderAgent.MxRuleCondition} condition
			 * @return {boolean} True if condition was added.<br>False if condition was not added as it already exists in group
			 */

			addCondition: function (condition) {
				if (!condition) {
					throw new Error('SearchQueryGroup: addCondition condition is not provided');
				}
				condition = angular.copy(condition) || {};
				condition.parent = this;
				var logicOperator = this.getChildrenOperator();
				if (logicOperator !== false) {
					condition.LogicOperator = logicOperator;
				}
				this.conditions.push(new ConditionsBuilderCondition(condition, this._builderConfig));
				this.updateOutput();
				return true;
			},

			/**
			 * @ngdoc method
			 * @name mx.SolutionBuilderAgent.SearchQueryGroup#removeCondition
			 *
			 * @description
			 * Removes condition from current group.<br>
			 * If condition does not exist within current group no actions performed.
			 *
			 * @param {guid} id - Search query condition id}
			 * @return {boolean} True if condition was removed.<br>False if condition was not removed as it was not in group
			 */
			removeCondition: function (condition) {
				var index = this.conditions.indexOf(condition);
				if (index >= 0) {
					this.conditions.splice(index, 1);
					this.updateOutput();
				}
			},

			toggleExpanded: function () {
				var expanded = !(this.conditions.length > 0 && this.conditions[0].expanded);
				this.expanded = expanded;
				this.conditions.forEach(function (condition) {
					condition.expanded = expanded;
				});
				this.groups.forEach(function (group) {
					group.expanded = expanded;
				});
			},

			updateOutput: function () {
				if (!this.initialized) {
					return;
				}
				if (typeof this._builderConfig.groupOutput === 'function') {
					this.output = this._builderConfig.groupOutput(this);
				}
				if (this.parent && typeof this.parent.updateOutput === 'function') {
					this.parent.updateOutput();
				}
			},

			clear: function () {
				this.groups = [];
				this.conditions = [];
			},
		};

		return ConditionsBuilderGroup;
	}
})();
